"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Adapted from https://github.com/huangjinlin/dayjs-precise-range
const RelativeTimePrecise = (option, dayjsClass, dayjsFactory) => {
  const STRINGS = {
    nodiff: "",
    year: "year",
    years: "years",
    month: "month",
    months: "months",
    day: "day",
    days: "days",
    hour: "hour",
    hours: "hours",
    minute: "minute",
    minutes: "minutes",
    second: "second",
    seconds: "seconds",
    delimiter: " "
  };
  function pluralize(num, word) {
    return num + " " + STRINGS[word + (num === 1 ? "" : "s")];
  }
  function buildStringFromValues(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff) {
    const result = [];
    if (yDiff) {
      result.push(pluralize(yDiff, "year"));
    }
    if (mDiff) {
      result.push(pluralize(mDiff, "month"));
    }
    if (dDiff) {
      result.push(pluralize(dDiff, "day"));
    }
    if (hourDiff) {
      result.push(pluralize(hourDiff, "hour"));
    }
    if (minDiff) {
      result.push(pluralize(minDiff, "minute"));
    }
    if (secDiff) {
      result.push(pluralize(secDiff, "second"));
    }
    return result.join(STRINGS.delimiter);
  }
  dayjsClass.prototype.fromNowPrecise = function () {
    let m1 = dayjsFactory(this),
      m2 = dayjsFactory();
    if (m1.isSame(m2)) {
      return STRINGS.nodiff;
    }
    if (m1.isAfter(m2)) {
      const tmp = m1;
      m1 = m2;
      m2 = tmp;
    }
    let yDiff = m2.year() - m1.year();
    let mDiff = m2.month() - m1.month();
    let dDiff = m2.date() - m1.date();
    let hourDiff = m2.hour() - m1.hour();
    let minDiff = m2.minute() - m1.minute();
    let secDiff = m2.second() - m1.second();
    if (secDiff < 0) {
      secDiff = 60 + secDiff;
      minDiff--;
    }
    if (minDiff < 0) {
      minDiff = 60 + minDiff;
      hourDiff--;
    }
    if (hourDiff < 0) {
      hourDiff = 24 + hourDiff;
      dDiff--;
    }
    if (dDiff < 0) {
      const daysInLastFullMonth = dayjsFactory(m2.year() + "-" + (m2.month() + 1)).subtract(1, "M").daysInMonth();
      if (daysInLastFullMonth < m1.date()) {
        // 31/01 -> 2/03
        dDiff = daysInLastFullMonth + dDiff + (m1.date() - daysInLastFullMonth);
      } else {
        dDiff = daysInLastFullMonth + dDiff;
      }
      mDiff--;
    }
    if (mDiff < 0) {
      mDiff = 12 + mDiff;
      yDiff--;
    }
    return buildStringFromValues(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff);
  };
};
var _default = exports.default = RelativeTimePrecise;
//# sourceMappingURL=RelativeTimePrecise.js.map